import $ from 'jquery';

export default (function($) {
  $(document).ready(function() {
    var dropdownHeight, backBtnCount = 0,
      elmList = [];
    $('.nav-list .nav-item.has-submenu').on('click', function(e) {
      e.stopPropagation();
      var _this = this;
      if ($('.login-btn-mobile').hasClass('hide')) {
        $('.login-btn-mobile').removeClass('hide');
      } else {
        $('.login-btn-mobile').addClass('hide');
      }
      $('.nav-list .nav-item.has-submenu .sub-menu-wrapper').removeClass('active').addClass('hide');
      $('.sub-sub-menu-wrapper').removeClass('active').addClass('hide');
      if ($(this).hasClass('active')) {
        $('html').css('overflow', 'auto');
        $(this).removeClass('active');
        $('.nav-list .nav-item.has-submenu').removeClass('active');
        $(this).find('.sub-menu-wrapper').removeClass('active').addClass('hide');
        return;
      }
      $('.nav-list .nav-item.has-submenu').removeClass('active');
      $(this).find('.sub-menu-item').map(function() {
        if(window.innerWidth > 600 ){
        $('html').css('overflow', 'hidden');
        }
        else{
        $('html').css('overflow', 'auto');
        }
        if (!($(this).hasClass('dropdown-submenu'))) {
          $(this).find('.content .sys-icon-arrowright-regular').hide();
        }
      })

      $(this).addClass('active');
      if ($(this).find('.sub-menu-wrapper')) {
        if ($('body').find('.hp-global-nav').length) {
          $('.nav-list .nav-item.active').addClass('top-115');
        }
        $(this).find('.sub-menu-wrapper').removeClass('hide');
        setTimeout(function() {
          $(_this).find('.sub-menu-wrapper').addClass('active');
        }, 0);
        dropdownHeight = $(this).find('.sub-menu-wrapper').height()+1;
        backBtnCount++;
        if ($(this).find('.sub-sub-menu-wrapper') && ($(this).find('.sub-menu').children('li').length === 1)) {
          $(this).find('ul.sub-menu li.sub-menu-item').children('.content').hide();
          $(this).find('.sub-sub-menu-list-container').css('border-top', 'none');
          if (window.innerWidth >= 768) {
            $(this).find('.sub-sub-menu-wrapper').addClass('active').removeClass('hide').css('height', dropdownHeight);
            }
            else {
            $(this).find('.sub-sub-menu-wrapper').addClass('active').removeClass('hide').css('height', 'auto');
            }
          }
      }
      $('#backBtn').removeClass('hide');
      elmList.push($(this));
    });
    $('.sub-menu-wrapper').on('click', function(e) {
      e.stopPropagation();
    });
    $("body,html").on('click', function() {
      if (window.innerWidth > 768) {
        $('.sub-menu-wrapper, .sub-sub-menu-wrapper').removeClass('active').addClass('hide');
        $('.nav-list .nav-item.has-submenu').removeClass('active');
      }
    });

    // Accessibility event listener when user hits esc button

    $(document).keyup(function (e) {
      if (e.keyCode === 27) {
       $('.nav-item.active').click();
      }
    });

    function search(){
      if ($('.search-container').hasClass('hide')) {
        $('.login-btn').hide();
        $('.sys-icon-close-Regular').removeClass('hide');
        $('.search-icon').addClass('active');
        $('.search-container').removeClass('hide');
        $('#search-box').focus();
        $('.nav-bar').addClass('hide');
      } else if (! ( $('.search-container').hasClass('hide') ) ){
        $('#search-id').submit();

      }
    }

    $(document).keypress(function (e) {
      if (e.which === 13){
        if($(e.target).hasClass('sys-icon-close-Regular'))
        {
          e.preventDefault();
          $('.sys-icon-close-Regular').trigger('click');
        }
        else{
          search();
        }
      }
    });

    $('.search-icon').on('click', function() {
      if (window.innerWidth <= 1024) {
        if ($('.search-container').hasClass('hide')) {
          if ($('body').find('.hp-global-nav').length) {
            $('.search-container').addClass('top-98');
          }
          $('html').css('overflow', 'hidden');
          $('.search-container').addClass('col-xs-9');
          $('#menuToggle').addClass('hide').removeClass('visible-xs');
        } else {
          $('html').css('overflow', 'auto');
          $('#menuToggle').removeClass('hide').addClass('visible-xs');
        }
      }
      search();
    });

    $('.sys-icon-close-Regular').on('click', function() {
      $('html').css('overflow', 'auto');
      if (window.innerWidth >= 768) {
        $('.sys-icon-close-Regular').addClass('hide');
        $('.login-btn').show();
        $('.search-icon').removeClass('active');
        $('.search-container').addClass('hide');
        $('.nav-bar').removeClass('hide');
      } else {
        $('.sys-icon-close-Regular').addClass('hide');
        if ($('.search-icon').hasClass('active')) {
          $('.search-icon').removeClass('active');
          $('.search-container').addClass('hide');
          $('#menuToggle').addClass('visible-xs').removeClass('hide');
        } else {
          $('.nav-bar').addClass('hide');
          $('#menuToggle').addClass('visible-xs').removeClass('hide');
          $(this).parents('.main-navbar').find('.nav-bar .nav-list').toggleClass('active');
        }
      }
    });

    $('.sub-menu-item.dropdown-submenu').on('click', function() {
      var _this = this;
      $('.sub-menu-item').removeClass('active');
      $('.sub-sub-menu-wrapper').removeClass('active').addClass('hide');
      $(this).addClass('active');
      if ($(this).find('.sub-sub-menu-wrapper')) {
        if (window.innerWidth >= 768) {
          $(this).find('.sub-sub-menu-wrapper').removeClass('hide').css('height', dropdownHeight);
        } else {
          $(this).find('.sub-sub-menu-wrapper').removeClass('hide').css('height', 'auto');
        }
        setTimeout(function() {
          $(_this).find('.sub-sub-menu-wrapper').addClass('active');
        }, 0);
        backBtnCount++;
      }
      elmList.push($(this));
    });

    $('#menuToggle').on('click', function(e) {
      if (window.innerWidth <= 1024) {
        $('.nav-list .nav-item.has-submenu, .sub-menu-wrapper, .sub-menu-item.dropdown-submenu, .sub-sub-menu-wrapper').removeClass('active');
        $('.sub-sub-menu-wrapper, .sub-menu-wrapper').addClass('hide');
        $(this).parents('.main-navbar').find('.nav-bar').removeClass('hidden-xs hide');
        $(this).parents('.main-navbar').find('.nav-bar .nav-list').addClass('active');
        $(this).parents('.login-search').find('#menuToggle').addClass('hide').removeClass('visible-xs');
        $(this).parents('.login-search').find('#closebtn').removeClass('hide');
        if ($(this).parents('.login-search').find('#closebtn').hasClass('hide')) {
          $('.login-btn-mobile').addClass('hide');
        } else {
          $('.login-btn-mobile').removeClass('hide');
        }
        $('html').css('overflow', 'hidden');
      }
    });

    $('#backBtn').on('click', function(e) {
      var currentElm = elmList.pop();
      if (!elmList.length) {
        $('#backBtn').addClass('hide');
        if (($('.sub-menu-wrapper').hasClass('active')) && ($('.sub-sub-menu-wrapper').hasClass('active')) && (currentElm.find('.content').css('display') == 'none')) {
          $('.login-btn-mobile').removeClass('hide');
        }
      }
      if (($('.sub-menu-wrapper').hasClass('active')) && !($('.sub-sub-menu-wrapper').hasClass('active')) && ($('.content').css('display') != 'none')) {
        $('.login-btn-mobile').removeClass('hide');
      }
      currentElm.removeClass('active');
      currentElm.find('.active').removeClass('active');
      setTimeout(function() {
        currentElm.find('.sub-sub-menu-wrapper').addClass('hide');
        currentElm.find('>.sub-menu-wrapper').addClass('hide');
      }, 500);
    });

    $('.nav-item').click(function() {
      var collapsed = $(this)
        .find('span')
        .hasClass('sys-icon-arrowdown-regular inverse');
      $('.has-submenu')
        .find('span')
        .removeClass('inverse');
      $(this)
        .find('span')
        .addClass('inverse');
      if (collapsed) {
        $(this)
          .find('span')
          .removeClass('inverse');
      }
    });
  });
})


// WEBPACK FOOTER //
// ./src/webpack/webapps/site-navigation.js